import React from 'react'
import { connect } from 'react-redux';
import { getProgressBarValue } from '../../reducers';

class ProgressBar extends React.Component {
  render() {
    const {
      progressValue,
      showNavbar,
    } = this.props

    if (!showNavbar) {
      return(null)
    }

    return(
      <div className="application-progress fixed-top">
        <div className="container" style={ { paddingTop: 0} }>
          <div className='d-flex d-xl-block'>
            <div className='progress d-block'>
              <div className='progress-bar' style={ {width:`${progressValue}%`, height: '20px'} } role="progressbar" aria-valuenow={progressValue} aria-valuemin="0" aria-valuemax="100">
              </div>
            </div>
            <div className='d-inline progress-text'>
              <strong>{progressValue}%</strong>
              <span style={ {paddingLeft: "5px"} }>complete</span>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  progressValue: getProgressBarValue(state),
  showNavbar: state.settings.showNavbar,
});

export default connect(mapStateToProps)(ProgressBar);
